module.exports = __webpack_public_path__ + "static/media/leonie2.7e8ae5a6.png";